import type { agencyTitle } from './payerEnrollments';

/**
 * A payer's first agency name, ending in "…" when long, then "+N more" kept
 * whole. Falls back to `fallback` when the agency has no name for it. The
 * caller's element must be a flex row for the truncation to work.
 */
export function PayerName({
  title,
  fallback,
}: {
  title: ReturnType<typeof agencyTitle>;
  fallback: string;
}) {
  return (
    <>
      <span className='truncate'>{title?.all[0] ?? fallback}</span>
      {title && title.all.length > 1 && (
        <span className='shrink-0 whitespace-nowrap'>
          &nbsp;+{title.all.length - 1} more
        </span>
      )}
    </>
  );
}
